import ArgoIcon from "./ArgoIcon";
import MsSqlServerIcon from "./MsSqlServerIcon";
import OracleIcon from "./OracleIcon";
import PostgreSqlIcon from "./PostgreSqlIcon";
import MySqlIcon from "./MySqlIcon";
import AwsIcon from "./AwsIcon";
import AzureIcon from "./AzureIcon";
import GcpIcon from "./GcpIcon";

export const Argo = ArgoIcon;
export const Aws = AwsIcon;
export const Azure = AzureIcon;
export const Gcp = GcpIcon;
export const MsSqlServer = MsSqlServerIcon;
export const Oracle = OracleIcon;
export const PostgreSql = PostgreSqlIcon;
export const MySql = MySqlIcon;
